import { RadioButtonGroup } from '@repo/go-ui';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import { LogsIndex } from '../api/types';
import styles from '../BasicParameters.module.scss';
import type { BasicParametersStore } from '../BasicParameters.store';

type Props = {
  store: BasicParametersStore;
};

export const LogsIndexSwitcher = observer(function LogsIndexSwitcher({ store }: Props) {
  const { t } = useTranslation();
  const { setLogsIndex, logsIndex } = store;

  const items = [
    {
      label: t('settings:time'),
      value: LogsIndex.TIME,
    },
    {
      label: t('settings:depth'),
      value: LogsIndex.DEPTH,
    },
  ];

  return (
    <RadioButtonGroup
      items={items}
      value={logsIndex}
      onChange={(v) => setLogsIndex(v)}
      className={styles.logIndexSwitcher}
    />
  );
});
